
const fixedNavbar = (($) => {
    $(function () {

        // 页面滚动处理事件
        document.addEventListener("scroll", function () {
            //执行移动端悬浮导航
            mobile_fixed_navbar_event()
            //执行PC 端悬浮导航
            pc_fixed_navbar_event()
        })

        /**
        * 移动端悬浮导航处理
        */
        var m = 0;

        var mobile_fixed_navbar_event = function () {
            //当屏幕小于 1024 即 移动端再执行下面代码
            if (window.innerWidth > 1023) return;

            var $navbar = $(".site-container-wrap .menuMobileBox")

            var scrollTop = $(window).scrollTop()

            if (scrollTop > m) {
                if (scrollTop > $navbar.outerHeight() * 1.5) {
                    // console.log($navbar);

                    $navbar.css({ transform: "translateY(-120%)", "transition-delay": "0.15s" })
                }
                m = scrollTop
            } else {
                $navbar.css({ transform: "translateY(0)", "transition-delay": "0.4s" })
                m = scrollTop
            }

        }
        /**
        * PC端悬浮导航处理
        */


        var $pcNavbar = $('nav.nav-secondary')

        // 克隆原来的导航
        var pc_clone_navbar = function () {
            if (document.getElementById('navbar-fixed') || window.innerWidth < 1024) return;
            var navFixed = $('<div id="navbar-fixed"></div>')
            navFixed.html($pcNavbar.clone(true))
            $('body').append(navFixed)
            //插入网站logo
            let host = "https://"+ window.location.host
            navFixed.find('.wrap').prepend('<a href="' + host + '"  class="logo"><img src="' + host + '/wp-content/themes/news-pro/images/white-logo@2x.png"></a>')


        }

        var pc_fixed_navbar_event = function () {
            var $navWarp = $('#navbar-fixed')

            //当屏幕大于 1024 即 移动端再执行下面代码
            if (window.innerWidth < 1024) return;

            var scrollTop = $(window).scrollTop()

            if (scrollTop > $pcNavbar.outerHeight() * 4) {
                $navWarp.css({ transform: "translateY(0%)", "transition-delay": "0.15s" }).addClass('_sticky')
                $navWarp.find('.logo').addClass('show')
            } else {
                $navWarp.css({ transform: "translateY(-120%)", "transition-delay": "" }).removeClass('_sticky')
                $navWarp.find('.logo').removeClass('show')
                $navWarp.find('.widget_search').css({ 'display': '' })
            }
        }


        /**
         * @description  封装一个debounce
         *
         * @param  {Function} fn Function to debounce.
         * @param  {Fn, Number}   delay
         * @return {Function}
         */
        function debounce(fn, delay) {
            delay = delay || 240;
            var debounceTimeout = null;
            return () => {
                var args = Array.prototype.slice.apply(arguments);
                clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(() => {
                    fn.apply(window, args);
                }, delay);
            };
        }

        $(window).on('resize', debounce(() => pc_clone_navbar(), 300)).trigger('resize')  //记得用debounce

        /**
         * 悬浮导航搜索框显示
         */
        var $searchBtn = $('.searchBoxInsideNav__button')
        $searchBtn.on('click', function (ev) {
            ev = ev || window.event
            if ($('#navbar-fixed').hasClass('_sticky')) {
                $('#navbar-fixed').find('.widget_search').css({ 'display': 'block' })
            }

            return false
        })
        // 防止搜索框冒泡
        $('.widget_search').on('click', function (ev) {
            ev = ev || window.event
            ev.stopPropagation()
        })

        $(document).on('click', function () {
            $('.widget_search').css({ 'display': '' })
        })

    })

    return fixedNavbar
})($)

export default fixedNavbar
